<template>
  <div class="relative flex justify-center gap-2">
    <DialogTitle class="font-Kontesa text-2xl leading-[33px] text-black">
      {{ name }} {{ number.toString().padStart(4, "0") }}
    </DialogTitle>
    <Box
      class="absolute right-0 top-0 h-12 w-12 shrink-0 bg-white"
      rounded="full"
    >
      <DialogClose class="flex h-full w-full items-center justify-center">
        <IconsClose class="h-5 w-5 stroke-[4]" />
      </DialogClose>
    </Box>
  </div>
</template>

<script lang="ts" setup>
import { useNfcName } from "~/domains/nfc/composables";
import type { NFCType } from "~/domains/nfc/types";

const props = defineProps<{
  type: NFCType;
  number: number;
}>();

const name = useNfcName(() => props.type);
</script>
